import ScheduleListRow from './ScheduleListRow';

const uuidv4 = require('uuid/v4');

export class AdditinalData {
	constructor(params) {
		this.code = params.code,
		this.additional_id = params.additional_id,
		this.additional_name = params.additional_name;
		this.value = params.value;
	}
	
	asHash() {
		return {
			code: this.code,
			additional_id: this.additional_id,
			additional_name: this.additional_name,
			value:  this.value,
		};
	}

	static createEmpty(additinalInfo) {
		return new AdditinalData({
			code: uuidv4(),
			additional_id: additinalInfo.code,
			additional_name: additinalInfo.name,
			value: '',
		});
	}
}

const createAdditinalData = (additinalData) => {
	return additinalData.map(data => {
		return new AdditinalData(data);
	});
};

export default class Project extends ScheduleListRow {
	get members() {
		return this.children;
	}
	
	constructor(params) {
		super(params);
		if (params.members !== undefined)
			this.children = params.members;
		
		if (params.project_additional !== undefined)
			this.project_additional = createAdditinalData(params.project_additional);
		else
			this.project_additional = new Array();

		this.item_type = ScheduleListRow.ITEM_TYPE.PROJECT;
	}
	
	static createEmpty() {
		return new Project({
			code: uuidv4(),
			name: '新しいプロジェクト',
			status: ScheduleListRow.STATUS.PROGRESS,
			seq: 1,
		});
	}
}
